/*
 * @Author: 神农西瓜
 * @Date: 2021-05-12 20:40:48
 * @LastEditTime: 2021-11-30 13:59:48
 * @LastEditors: 神农西瓜
 * @Description: 
 * @FilePath: /otherFiles/STO_ERP/src/config/global.js
 */
let APP_ID; // 飞书自建程序appid
let SERVER; // 线上地址
let BASE_URL; // api地址
let REDIRECT_URI; // 登录回调url
let APP_LINK_FLAG; // 是否开启飞书 AppLink 跳转

console.log(process.env.VUE_APP_TITLE);
const runtimeOrigin = (typeof window !== "undefined" && window.location && window.location.origin)
  ? window.location.origin
  : "";
const envServer = process.env.VUE_APP_SERVER || "";
const envBaseUrl = process.env.VUE_APP_BASE_URL || "";
const envRedirectUri = process.env.VUE_APP_REDIRECT_URI || "";

// 判断当前是否为生产环境
if (process.env.VUE_APP_TITLE == "production") {
  // 生产环境
  APP_ID = "cli_a8e8d93071b1901c";
  SERVER = envServer || runtimeOrigin || "https://cerp.hszskj.com/";
  BASE_URL = envBaseUrl || "https://cerp.hszskj.com/";
  REDIRECT_URI = envRedirectUri || SERVER;
  APP_LINK_FLAG = false;
} else if (process.env.VUE_APP_TITLE == "test") {
	// 生产环境
	APP_ID = "cli_a8e8d93071b1901c";
	SERVER = envServer || runtimeOrigin || "https://cerp.hszskj.com/";
	BASE_URL = envBaseUrl || "https://cerp.hszskj.com/";
	REDIRECT_URI = envRedirectUri || SERVER;
	APP_LINK_FLAG = false;
} else {
  // 测试环境
  APP_ID = "cli_a8e8d93071b1901c";
  SERVER = envServer || runtimeOrigin || "https://cerp.hszskj.com/";
  // BASE_URL = "http://www.cerp.test";
  BASE_URL = envBaseUrl || "https://cerp.hszskj.com/";
  // BASE_URL = "https://cerp.toasin.cn";
  REDIRECT_URI = envRedirectUri || SERVER;
  APP_LINK_FLAG = false;
}

export { SERVER, BASE_URL, REDIRECT_URI, APP_LINK_FLAG, APP_ID };
